import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-carbon-100 text-carbon-30 border-t border-carbon-90">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-14">

          {/* ── Brand col ─────────────────────────────────────── */}
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-3 mb-5 group w-fit">
              <div className="w-8 h-8 bg-carbon-90 border border-carbon-70 flex items-center justify-center p-1.5 group-hover:bg-primary-500 group-hover:border-primary-500 transition-colors">
                <img src={logo} alt="Rahmani Foundation" className="w-full h-full object-contain" />
              </div>
              <div>
                <span className="block text-white font-semibold text-sm leading-tight">Rahmani Foundation</span>
                <span className="block text-[10px] text-primary-400 uppercase tracking-[0.14em] mt-0.5">Donation Platform</span>
              </div>
            </Link>
            <p className="text-sm text-carbon-40 leading-relaxed mb-6 max-w-xs">
              Empowering communities through transparent, secure, and impactful humanitarian giving.
            </p>
            {/* Social */}
            <div className="flex gap-2">
              {[
                { name: 'Facebook', href: 'https://www.facebook.com/RahmaniMission', d: 'M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z' },
                { name: 'Instagram', href: 'https://www.instagram.com/rahmanifoundation', d: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z' },
              ].map(({ name, href, d }) => (
                <a key={name} href={href} target="_blank" rel="noopener noreferrer" aria-label={name}
                  className="w-8 h-8 border border-carbon-70 flex items-center justify-center text-carbon-50 hover:text-white hover:border-primary-500 hover:bg-primary-500 transition-all">
                  <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
                    <path d={d} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* ── Links ────────────────────────────────────────── */}
          <div className="md:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-8 lg:gap-10">
            <div>
              <h4 className="text-white text-xs font-semibold uppercase tracking-widest mb-4">Platform</h4>
              <ul className="space-y-3">
                {[
                  { label: 'Projects', path: '/projects' },
                  { label: 'Dashboard', path: '/dashboard' },
                  { label: 'My Donations', path: '/donations/my-donations' },
                  { label: 'Receipts', path: '/receipts' },
                ].map(({ label, path }) => (
                  <li key={path}>
                    <Link to={path} className="text-xs text-carbon-40 hover:text-white transition-colors leading-relaxed">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white text-xs font-semibold uppercase tracking-widest mb-4">Support</h4>
              <ul className="space-y-3">
                {[
                  { label: 'Help Center', href: 'mailto:togetherwerise@rahmanimission.org?subject=Help%20Request' },
                  { label: 'Privacy Policy', href: 'mailto:togetherwerise@rahmanimission.org?subject=Privacy%20Inquiry' },
                  { label: 'Terms of Use', href: 'mailto:togetherwerise@rahmanimission.org?subject=Terms%20Inquiry' },
                  { label: 'Contact Us', href: 'mailto:togetherwerise@rahmanimission.org' },
                ].map(({ label, href }) => (
                  <li key={label}>
                    <a href={href} className="text-xs text-carbon-40 hover:text-white transition-colors leading-relaxed">{label}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-span-2 sm:col-span-1">
              <h4 className="text-white text-xs font-semibold uppercase tracking-widest mb-4">Institution</h4>
              <div className="space-y-2 text-xs text-carbon-40 leading-relaxed">
                <p>Nawab Kothi, Belan Bazar<br />Munger, Bihar 811201</p>
                <p className="font-mono text-[11px]">URN: AABTR3613FF20221</p>
                <a
                  href="mailto:togetherwerise@rahmanimission.org"
                  className="text-primary-400 hover:text-primary-300 transition-colors break-all text-[11px]"
                >
                  togetherwerise@rahmanimission.org
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* ── Bottom bar ──────────────────────────────────────── */}
        <div className="mt-12 pt-6 border-t border-carbon-90 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-[11px] text-carbon-50">
            © {year} Rahmani Foundation. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-teal-400 animate-pulse-dot" style={{ borderRadius: 0 }} />
            <span className="text-[10px] text-carbon-50 uppercase tracking-widest">Systems Online</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
